import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MadMissingTranslationHandler implements MissingTranslationHandler {
    public handle(params: MissingTranslationHandlerParams): string {
        /* eslint-disable @typescript-eslint/dot-notation */
        if (params.interpolateParams?.['fallback']) {
            return params.translateService.instant(params.interpolateParams['fallback']);
            /* eslint-enable @typescript-eslint/dot-notation */
        }
        return params.key;
    }
}
